import React from 'react';
import { MapPin, Navigation, ExternalLink } from 'lucide-react';
import { Helmet } from 'react-helmet-async';

export default function FindVej() {
  const address = "Bernstorffsvej 20 C, 2.sal, 2900 Hellerup";
  const mapsUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`;

  return (
    <main className="pt-32 pb-24">
      <Helmet>
        <title>Find vej & Parkering | Hellerup Lægehus</title>
        <meta name="description" content="Find vej til Hellerup Lægehus på Bernstorffsvej 20 C, 2. sal i Hellerup. Se kort, parkeringsforhold og offentlig transport her." />
        <meta property="og:title" content="Find vej & Parkering | Hellerup Lægehus" />
        <meta property="og:description" content="Find vej til Hellerup Lægehus på Bernstorffsvej 20 C, 2. sal i Hellerup. Se kort, parkeringsforhold og offentlig transport her." />
        <html lang="da-DK" />
      </Helmet>
      <div className="max-w-7xl mx-auto px-6">
        <div className="mb-20">
          <div className="flex items-center gap-4 mb-6">
            <div className="h-[1px] w-12 bg-[#4b717a]" />
            <span className="text-[#4b717a] text-xs tracking-[0.4em] uppercase font-bold">Find os</span>
          </div>
          <h1 className="text-5xl md:text-6xl font-sans font-medium text-black mb-8 leading-tight tracking-tight">Find vej til <br />klinikken</h1>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start">
          <div className="flex flex-col gap-10">
            <div className="bg-slate-50 p-10 border border-slate-100">
              <div className="flex gap-6 mb-8">
                <div className="text-black shrink-0">
                  <MapPin size={32} />
                </div>
                <div>
                  <h2 className="text-2xl font-sans font-medium text-black mb-2 leading-tight tracking-tight">Adresse</h2>
                  <p className="text-slate-600 text-lg leading-relaxed">
                    Bernstorffsvej 20 C, 2.sal<br />
                    2900 Hellerup
                  </p>
                </div>
              </div>

              <div className="space-y-4">
                <a 
                  href={mapsUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-full bg-slate-900 hover:bg-slate-800 text-white py-5 flex items-center justify-center gap-3 transition-all group"
                >
                  <Navigation size={20} className="group-hover:rotate-12 transition-transform" />
                  <span className="text-sm tracking-[0.3em] uppercase font-bold">Åbn i Google Maps</span>
                  <ExternalLink size={16} className="opacity-50" />
                </a>
                <p className="text-xs text-slate-400 text-center italic">
                  Klinikken er beliggende på 2. sal. Der er elevator i opgangen.
                </p>
              </div>
            </div>

            <div className="flex flex-col gap-6">
              <h3 className="text-xs tracking-[0.3em] uppercase font-bold text-slate-400">Transport & Parkering</h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                <div>
                  <h4 className="font-sans font-medium text-black mb-2">Offentlig transport</h4>
                  <p className="text-slate-500 text-sm leading-relaxed">
                    Klinikken ligger tæt på Hellerup Station og adskillige buslinjer (bl.a. 1A og 166) stopper i nærheden.
                  </p>
                </div>
                <div>
                  <h4 className="font-sans font-medium text-black mb-2">Parkering</h4>
                  <p className="text-slate-500 text-sm leading-relaxed">
                    Der er gode parkeringsmuligheder i området omkring Bernstorffsvej. Husk at tjekke skiltningen for tidsbegrænsning.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="h-[500px] bg-slate-100 relative overflow-hidden group">
            <iframe 
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2246.345678901234!2d12.5678901!3d55.7345678!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4652528888888888%3A0x8888888888888888!2sBernstorffsvej%2020C%2C%202900%20Hellerup!5e0!3m2!1sda!2sdk!4v1234567890123" 
              width="100%" 
              height="100%" 
              style={{ border: 0 }} 
              allowFullScreen="" 
              loading="lazy" 
              referrerPolicy="no-referrer-when-downgrade"
              title="Kort over Hellerup Lægehus"
              className="grayscale contrast-125 opacity-80 group-hover:grayscale-0 group-hover:opacity-100 transition-all duration-700"
            ></iframe>
          </div>
        </div>
      </div>
    </main>
  );
}
